import { Outlet } from 'react-router-dom';

const ManagerMeetingsOutlet = () => {
    return (
            <Outlet />
    )
}

export default ManagerMeetingsOutlet